import React, { useState, useEffect } from "react";
import Container from "react-bootstrap/Container";
import Navbar from "react-bootstrap/Navbar";
import { ReactComponent as Logo2 } from "../assets/img/WOWCRUISE.svg";
import { ReactComponent as DotIcon } from "../assets/icons/svg/dot.svg";
import currency from "../assets/img/currency.svg";
import { Link, useLocation, useNavigate } from "react-router-dom";
import SideBar from "./sidebar";
import Nav from "react-bootstrap/Nav";
import { ReactComponent as ArrowLeftIcon } from "../assets/icons/svg/arrowLeft.svg";
import { usePageTitle } from '../contexts/PageTitleContext';
import { useUser } from '../contexts/UserContext';
import { apiGet } from '../utils/api';

export default function AppHeader() {
  const [isToggled, setIsToggled] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 651);
  const [isTablet, setIsTablet] = useState(window.innerWidth <= 1327);

  const { user, setUser } = useUser();
  const { pageTitle: currentPageTitle } = usePageTitle();
  const location = useLocation();
  const navigate = useNavigate();

  const isHomePage = location.pathname === "/";
  const isAuthPage =
    location.pathname === "/register" ||
    location.pathname === "/login";
  const isMypageBaseRouteHeader = location.pathname === "/mypage" || location.pathname === "/mypage/";
  const isBookMarkPage = location.pathname === '/bookmark';
  const showMobileBackButton = isMobile && !isHomePage && !isAuthPage && !isMypageBaseRouteHeader && !isBookMarkPage;
  const showMobilePageTitle = isMobile && !isHomePage && !isAuthPage && currentPageTitle;

  const handleToggle = () => {
    setIsToggled(!isToggled);
  };

  const handleLinkClick = () => {
    setIsToggled(false);
  };

  // 로그아웃 처리
  const handleLogout = async () => {
    try {
      const res = await apiGet('/member/logout.php');
      if (res.result === 'success') {
        setUser(null);        // UserContext 상태 초기화
        navigate('/');        // 홈으로 이동
      } else {
        alert('로그아웃 실패: ' + (res.message || '알 수 없는 오류'));
      }
    } catch (error) {
      console.error('Logout error:', error);
      alert('서버 오류로 로그아웃에 실패했습니다.');
    }
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 651);
      setIsTablet(window.innerWidth <= 1327);
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      <section className="header">
        <Navbar expand="xl">
          <Container fluid style={{ position: 'relative' }}>
            {isMobile ? (
              <>
                <div className="mobile-header-side">
                  {showMobileBackButton && (
                    <button
                      type="button"
                      className="mobile-header-back"
                      onClick={() => navigate(-1)}
                      aria-label="이전 페이지로 이동"
                    >
                      <ArrowLeftIcon />
                    </button>
                  )}
                </div>

                <Link to="/" className="mobile-header-logo" aria-label="WOWCRUISE 홈으로 이동">
                  <Logo2 />
                </Link>

                <button
                  className='custom-toggler'
                  onClick={handleToggle}
                  aria-label="메뉴 열기"
                >
                  <span />
                  <span />
                  <span />
                </button>
              </>
            ) : (
              <>
                <Navbar.Brand as="div" style={{ zIndex: 1 }}>
                  <Link to="/" style={{ textDecoration: 'none', cursor: 'pointer' }}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <Logo2 />
                      {!isTablet && (
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <div style={{ width: '20px', height: '20px', display: 'flex', justifyContent: "center", alignItems: 'center' }}><DotIcon /></div>
                          <span style={{ fontSize: '14px', fontWeight: '400', lineHeight: '160%', color: '#4E5867' }}>당신을 '와우'하게 만들 크루즈 여행</span>
                        </div>
                      )}
                    </div>
                  </Link>
                </Navbar.Brand>

                <div className="cstm-top-navlinks"></div>

                <div className="navbar-right-profile">
                  <div className="buttons header with-review-link">
                    <img src={currency} alt="currency" className="currency" />
                    <Nav.Link as={Link} to="/review" className="nav-links">
                      고객후기
                    </Nav.Link>
                    <Nav.Link as={Link} to="/bookmark" className="nav-links">
                      찜한 여행
                    </Nav.Link>
                    {user ? (
                      <>
                        <Nav.Link as={Link} to="/mypage" className="nav-links">
                          마이페이지
                        </Nav.Link>
                        <Nav.Link as="span" className="nav-links" onClick={handleLogout}>
                          로그아웃
                        </Nav.Link>
                      </>
                    ) : (
                      <>
                        <Nav.Link as={Link} to="/register" className="nav-links">
                          회원가입
                        </Nav.Link>
                        <Nav.Link as={Link} to="/login" className="nav-links">
                          로그인
                        </Nav.Link>
                      </>
                    )}
                  </div>
                </div>
              </>
            )}
          </Container>
        </Navbar>
      </section>
      {showMobilePageTitle && (
        <>
          <div className="mobile-page-title-bar">
            <h1>{currentPageTitle}</h1>
          </div>
          <div className="mobile-page-title-spacer" aria-hidden="true" />
        </>
      )}
      <SideBar isToggled={isToggled} onLinkClick={handleLinkClick} />
    </>
  );
}
